import { useContext } from "react";
import LanguageContext from "../context/LanguageContext_Provider"

const useTranslate = () => {
    return useContext(LanguageContext)
}

export default useTranslate
